import React, { createContext, useContext } from 'react';

const AdminContext = createContext(null);

export const AdminProvider = ({ children, value }) => (
  <AdminContext.Provider value={value}>{children}</AdminContext.Provider>
);

export const useAdmin = () => {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error('useAdmin must be used inside AdminProvider');
  return ctx;
};
